const INITIAL_STATE = {
  userFunctionsList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_USER_FUNCTIONS_LIST':
      return { ...state, userFunctionsList: action.userFunctions };
    default:
      return state;
  }
};
